import { render, staticRenderFns } from "./AddWarrantsPayments.vue?vue&type=template&id=37136431&scoped=true"
import script from "./AddWarrantsPayments.vue?vue&type=script&lang=js"
export * from "./AddWarrantsPayments.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "37136431",
  null
  
)

export default component.exports